module.exports = __webpack_public_path__ + "img/coloroflaw.a406518e.jpg";